import { useState, useEffect } from 'react';

export const useScroll = () => {
  const [scrollY, setScrollY] = useState(0);
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.pageYOffset;
      setScrollY(currentScroll);

      if (currentScroll > 250) {
        const percentage = Math.min((currentScroll - 200) / 50, 1);
        setScrollPercentage(percentage);
        setIsScrolled(percentage === 1);
      } else {
        setScrollPercentage(0);
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { scrollY, scrollPercentage, isScrolled };
};

